<template>
  <section id="partners" class="section-block">
    <div class="section-container">
      <span v-reveal class="section-label">Partners</span>
      <h2 v-reveal class="section-title">{{ $t("partners") }}</h2>
      <p v-reveal class="section-subtitle reveal--delay-1 section-subtitle--center">
        与众多跨境企业携手，共建数字化生态
      </p>
      <div class="partners-wall" role="list">
        <div
          v-for="(item, index) in partners"
          :key="item.id"
          v-reveal
          role="listitem"
          class="partner-item"
          :class="'reveal--delay-' + (index % 5 + 1)"
          :aria-label="item.name"
        >
          <img :src="item.logo" alt="" class="partner-logo" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    partners: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.section-subtitle--center {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.partners-wall {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 28px 20px;
  margin: 0 auto;
  padding: 4px 0 0;
  justify-items: center;
  align-items: center;
}

.partner-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 55px;
  padding: 6px 12px;
  box-sizing: border-box;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: var(--bg);
  transition: transform 0.3s, box-shadow 0.3s;
}

.partner-item:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow);
}

.partner-logo {
  width: auto;
  max-width: 100%;
  height: 100%;
  max-height: 40px;
  object-fit: contain;
  display: block;
  transition: transform 0.3s;
}

.partner-item:hover .partner-logo {
  transform: scale(1.05);
}

@media (prefers-reduced-motion: reduce) {
  .partner-item:hover {
    transform: none;
  }

  .partner-item:hover .partner-logo {
    transform: none;
  }
}

@media (max-width: 991px) {
  .partners-wall {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 24px 16px;
  }

}

@media (max-width: 480px) {
  .partners-wall {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
